<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red" style="background-color: #ec5d59 !important;">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">我的幸运大抽奖</div>

        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>

    <div class="sign-record">
      <div class="list" v-if="info.length > 0">
        <div class="item" v-for="(item, index) in info" :key="index">
          <div class="data">{{ item._add_day }} </div>

          <div class="listn" >
            <div class="itemn acea-row row-between-wrapper" >
              <div class="name line1" style="width:50%;">{{ item.name }}</div>

              <div style="float:right;width:50%;text-align:right;" class="num" v-if="item.url!=''">
                <router-link :to="item.url" style="color:red;font-size:0.3rem;">{{item.give_msg}}</router-link>
              </div>

              <div style="float:right;width:50%;text-align:right;color:#666;font-size:0.3rem;" class="num" v-if="item.url==''">
                {{item.give_msg}}
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="shoppingCart">
        <div  style="margin-top:0px;"
              class="noCart"
              v-if="showno === 0"
        >
          <div class="pictrue"><img src="@assets/images/noList.png" /></div>
        </div>
      </div>

    </div>



    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<style>
  .sign-record .list .item .listn th{
    padding:0.15rem 0px;
  }
  .sign-record .list .item .listn .listntime {
    padding-left:0.15rem;
  }
  .sign-record .list .item .listn td{
    padding:0.30rem 0px;
  }
  .sign-record .list .item .listn{
    font-size: 0.28rem;
    color: #282828;

  }
  .sign-record .list .item .listn2{
    border-bottom:1px solid #eee;
  }
  .bonus_show {
    color:#ec5d59;
    font-size:0.2rem;
  }
</style>

<script>
  import {  getMyLuckyList } from "../../api/user";
  import Loading from "@components/Loading";
  const NAME = "mylucky";
  export default {
    name: NAME,
    components: {
      Loading
    },
    props: {},
    data: function() {
      return {
        showno:1,
        info: [],
        where: {
          page: 1,
          limit: 20,
        },
        loaded: false,
        loading: false
      };
    },
    watch: {
      $route(n) {
        if (n.name === NAME) {
          this.info = [];
          this.loaded= false;
          this.loading= false;
          this.where.page = 1;
          this.getIndex();
        }
      }
    },
    mounted: function() {
      this.getIndex();
      this.$scroll(this.$refs.container, () => {
        this.loading === false && this.getIndex();
      });
    },
    methods: {
      getIndex: function() {
        let that = this;
        if (that.loading == true || that.loaded == true) return;
        that.loading = true;
        getMyLuckyList(that.where).then(
                res => {
                  that.loading = false;
                  that.loaded = res.data.list.length < that.where.limit;
                  that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
                  that.where.page = that.where.page + 1;
                  that.info.push.apply(that.info, res.data.list);
                  if(that.info.length==0){
                    that.showno=0;
                  }
                },
                error => {
                  that.$dialog.message(error.msg);
                }
        );
      }
    }
  };
</script>
